import React, { useMemo } from 'react'
import { FlexView } from 'components/common'
import TabsTlh from 'containers/layout/Tabs'
// simport Results from 'containers/layout/Results'
import { useTranslation } from 'react-i18next'
// import { UserContext } from 'stores/UserStore'
// import { TubularContext } from 'stores/TubularStore'


const Home = () => {
  const { t } = useTranslation()

  // const { registryLogOld, registryLog } = useContext(UserContext)
  // const { getClient } = useContext(TubularContext)

  // useEffect(() => {
  // registryLogOld('client_in', '/tlh/home')
  // registryLog('home', 'navigation', 'client_in')
  // getClient()
  // }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const options = useMemo(() => [
    {
      key: 'ippn',
      label: t('tlh.home.tabs.ippn')
    },
    // {
    //   key: 'valid',
    //   label: t('tlh.home.tabs.valId')
    // },
    {
      key: 'sot',
      label: t('tlh.home.tabs.sot')
    },
    {
      key: 'purchaseOrder',
      label: t('tlh.home.tabs.purchaseOrder')
    },
    {
      key: 'salesOrder',
      label: t('tlh.home.tabs.salesOrder')
    },
    {
      key: 'invoice',
      label: t('tlh.home.tabs.invoice')
    },
    {
      key: 'reservation',
      label: t('tlh.home.tabs.reservation')
    }
  ], [t])

  return <FlexView alignSelf="center" justifyContent="center" alignItems="center" width="100%">
    <TabsTlh options={options} firtsActiveKey={'ippn'} />
  </FlexView>
}

export default Home
